import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function HomeSearchBox() {
  const { userID, RendomTokenfetch, userRoll } = useAuth();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState({
    categories: [],
    services: [],
    plans: [],
  });
  const [showSuggestions, setShowSuggestions] = useState(false);

  const searchBoxRef = useRef(null);

  //Debounced API Call
  useEffect(() => {
    const timer = setTimeout(() => {
      const keyword = searchQuery.trim();
      if (keyword === "") {
        setSuggestions({ categories: [], services: [], plans: [] });
        return;
      }

      const fetchSearchResults = async () => {
        try {
          const fdata = new FormData();
          fdata.append("userid", userID);
          fdata.append("role_id", userRoll);
          fdata.append("keyword", keyword);

          const response = await axios.post(
            `${WebsiteAPIurl}homePageSearch`,
            fdata,
            {
              headers: {
                Authorization: RendomTokenfetch,
              },
            }
          );

          if (response.data.Status === "1") {
            setSuggestions({
              categories: response.data.categorydata || [],
              services: response.data.servicedata || [],
              plans: response.data.searchServiceplan || [],
            });
            setShowSuggestions(true); // show only when results found
          } else {
            setSuggestions({ categories: [], services: [], plans: [] });
            setShowSuggestions(false);
          }
        } catch (error) {
          console.error("Search error:", error);
        }
      };

      fetchSearchResults();
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery, userID, userRoll, RendomTokenfetch]);

  //  Click outside to hide suggestions
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const highlightText = (text, keyword) => {
    const regex = new RegExp(`(${keyword})`, "gi");
    return text?.replace(regex, "<mark>$1</mark>");
  };

  const handleSelectSuggestion = (item, type) => {
    setSearchQuery(
      type === "plans" ? item.plan_title : item.category || item.title
    );
    setSuggestions({ categories: [], services: [], plans: [] });
    setShowSuggestions(false);

    if (type === "categories") {
      navigate(`/services/${item.cat_slug}`);
    } else if (type === "services") {
      navigate(`/service/${item.service_slug}`);
    } else if (type === "plans") {
      navigate(`/plans/${item.slug}`);
    }
  };

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="row justify-content-between" ref={searchBoxRef}>
        <div className="form-group col-lg-12 col-md-12 col-sm-12">
          <span className="icon">
            <i className="fa fa-search" aria-hidden="true"></i>
          </span>
          <input
            type="text"
            name="field_name"
            placeholder="Service Name or City Keyword"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => {
              if (
                suggestions.categories.length > 0 ||
                suggestions.services.length > 0 ||
                suggestions.plans.length > 0
              ) {
                setShowSuggestions(true);
              }
            }}
            autoComplete="off"
          />

          {/* Dropdown Suggestion Box */}
          {showSuggestions && (
            <div
              className="list-group position-absolute zindex-dropdown bg-white p-2"
              style={{
                top: "100%",
                maxHeight: "300px",
                overflowY: "auto",
                zIndex: "9999",
                width: "95%",
                border: "1px solid #ddd",
              }}
            >
              <>
                {suggestions.categories.length > 0 && (
                  <>
                    <strong className="text-primary mb-1 d-block">
                      Category
                    </strong>
                    {suggestions.categories.map((item, index) => (
                      <div
                        key={`cat-${index}`}
                        className="list-group-item list-group-item-action"
                        onClick={() =>
                          handleSelectSuggestion(item, "categories")
                        }
                        style={{ cursor: "pointer", fontSize: "14px" }}
                        dangerouslySetInnerHTML={{
                          __html: highlightText(item.category, searchQuery),
                        }}
                      ></div>
                    ))}
                    <hr className="my-2" />
                  </>
                )}

                {suggestions.services.length > 0 && (
                  <>
                    <strong className="text-success mb-1 d-block">
                      Services
                    </strong>
                    {suggestions.services.map((item, index) => (
                      <div
                        key={`serv-${index}`}
                        className="list-group-item list-group-item-action"
                        onClick={() => handleSelectSuggestion(item, "services")}
                        style={{ cursor: "pointer", fontSize: "14px" }}
                        dangerouslySetInnerHTML={{
                          __html: highlightText(item.title, searchQuery),
                        }}
                      ></div>
                    ))}
                    <hr className="my-2" />
                  </>
                )}

                {suggestions.plans.length > 0 && (
                  <>
                    <strong className="text-success mb-1 d-block">Plans</strong>
                    {suggestions.plans.map((item, index) => (
                      <div
                        key={`plan-${index}`}
                        className="list-group-item list-group-item-action"
                        onClick={() => handleSelectSuggestion(item, "plans")}
                        style={{ cursor: "pointer", fontSize: "14px" }}
                        dangerouslySetInnerHTML={{
                          __html: highlightText(item.plan_title, searchQuery),
                        }}
                      ></div>
                    ))}
                  </>
                )}
              </>
            </div>
          )}
        </div>
      </div>
    </form>
  );
}
